import { Box } from "arkh";
import React from "react";

export function RoutineOccasionIssueContainer(props: {
  children: React.ReactNode;
  isLast: boolean;
  isFirst: boolean;
}) {
  return (
    <Box
      spaceHorizontal="medium"
      spaceBottom={props.isLast ? "medium" : "xxsmall"}
      style={{
        flexDirection: "row",
        alignItems: "center",
        flex: 1,
      }}
    >
      <Box
        spaceHorizontal="medium"
        spaceBottom={props.isLast ? "medium" : "none"}
      >
        <Box
          style={{ flex: 0, height: "100%", width: 3 }}
          color="border-primary"
        />
      </Box>
      <Box
        spaceBottom="xsmall"
        spaceTop={props.isFirst ? "small" : "xsmall"}
        style={{
          flex: 1,
          marginHorizontal: -1,
          paddingHorizontal: 1,
        }}
      >
        {props.children}
      </Box>
    </Box>
  );
}
